import React from 'react';
import styled from '@emotion/styled/macro';
import vars from '@variables';
import { Link } from 'gatsby';
import { GTM_ID } from '../../../../../common/constants/gtmIds';
import { NavbarDescriptionLinkProps } from './navbar-description-link.types';
import { shouldForwardProp } from '@utils/utils';
import { WrapperProps } from '../navbar-atoms-common.types';

const StyledExternalLink = styled.a<WrapperProps>`
  text-decoration: none;
  display: block;
  padding: ${vars.spacingM};
  margin-left: -${vars.spacingM};
  border-radius: 4px;

  &:hover {
    background-color: ${({ hasBackground }) =>
      hasBackground ? '#fff' : '#f9fafb'};
  }
`;

const StyledLink = styled(Link, {
  shouldForwardProp: prop => shouldForwardProp(['hasBackground'], prop),
})<WrapperProps>(({ hasBackground }) => {
  return `
    text-decoration: none;
    display: block;
    padding: ${vars.spacingM};
    margin-left: -${vars.spacingM};
    border-radius: 4px;
  
    &:hover {
      background-color: ${hasBackground ? '#fff' : '#f9fafb'};
    }
  `;
});

const Title = styled.p`
  font-size: 1.6rem;
  font-weight: ${vars.fontWeightMedium};
`;

const Description = styled.p`
  font-size: 1.4rem;
  font-weight: ${vars.fontWeightRegular};
  color: ${vars.lightGrey};
`;

const Pill = styled.div`
  margin-left: ${vars.spacingXs};
  font-size: 8px;
  color: ${({ color }) => color || '#2F2F46'};
  line-height: 8px;
  border: 1px solid ${({ color }) => color || '#8F8F9B'};
  border-radius: 10px;
  padding: 3px 6px 2px;
  text-transform: uppercase;
  white-space: nowrap;
  font-weight: ${vars.fontWeightBold};
`;

const FlexWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: ${vars.spacingXs};
`;

const Wrapper: React.FC<WrapperProps> = ({
  isExternal,
  link,
  children,
  hasBackground,
  gtmId,
  handleReset,
}) => {
  if (isExternal) {
    return (
      <StyledExternalLink
        href={link}
        data-gtm-id={gtmId}
        hasBackground={hasBackground}
        target="_blank"
        rel="noreferrer noopener"
        onClick={handleReset}
      >
        {children}
      </StyledExternalLink>
    );
  }
  return (
    <StyledLink
      to={link || ''}
      data-gtm-id={gtmId}
      hasBackground={hasBackground}
      onClick={handleReset}
    >
      {children}
    </StyledLink>
  );
};

export const NavbarDescriptionLink: React.FC<NavbarDescriptionLinkProps> = ({
  item,
  columnNumber,
  hasBackground,
  handleReset,
}) => {
  return (
    <Wrapper
      link={item.linkPath}
      gtmId={`${GTM_ID.FLYOVER_LINK_COLUMN}${columnNumber}`}
      hasBackground={hasBackground}
      isExternal={item.isExternalLink}
      handleReset={handleReset}
    >
      <FlexWrapper>
        <Title>{item.title}</Title>
        {item.pillTitle && <Pill color={item.pillColor}>{item.pillTitle}</Pill>}
      </FlexWrapper>

      <Description>{item.description}</Description>
    </Wrapper>
  );
};
